import { ICoreDetailsModel } from "../models/customer/core-details.model";
import { ICoreDetailsDtoModel } from "../models/customer/dto/core-details-dto.model";
import { ICoreDetailsUpdateDtoModel } from "../models/customer/dto/core-details-update-dto.model";
import { ITaxNumberDtoModel } from "../models/tax-number/tax-number-dto.model";
import { IModelMapping } from "./generic/model.mapping";

export class CoreDetailsMapping implements IModelMapping<ICoreDetailsDtoModel, ICoreDetailsModel>  {
    toApplicationModel(model: ICoreDetailsDtoModel): ICoreDetailsModel {
        return {
            ...model
        } as ICoreDetailsModel;
    }

    toDtoModel(model: ICoreDetailsModel): ICoreDetailsDtoModel {
        return {
            ...model
        } as ICoreDetailsDtoModel;
    }

    toDtoUpdateModel(model: ICoreDetailsModel): ICoreDetailsUpdateDtoModel {
        return {
            ...model,
            accountName: model.customerType?.code == 'BUS' ? model.companyName : model.accountName,
            taxRegistrationNumber: model.taxRegistrationNumber?.number ? {
                number: model.taxRegistrationNumber?.number,
                lastChecked: model.taxRegistrationNumber?.lastChecked && model.taxRegistrationNumber?.lastChecked != '' && model.taxRegistrationNumber?.lastChecked != 'undefined' ? model.taxRegistrationNumber?.lastChecked : null
            } as ITaxNumberDtoModel : undefined,
            individualCustomer: model.customerType?.code == 'IND' ? true : false,
            managedByUsername: model.managedByUsername
        } as ICoreDetailsUpdateDtoModel;
    }

    toDtoModels(models: ICoreDetailsModel[]): ICoreDetailsDtoModel[] {
        return { ...models } as ICoreDetailsDtoModel[];
    }

    toApplicationModels(models: ICoreDetailsDtoModel[]): ICoreDetailsModel[] {
        return models.map(m => this.toApplicationModel(m));
    }
}
